import { useAbyssTheme } from "@uhg-abyss/web/hooks/useAbyssTheme";
import { Footer } from "@uhg-abyss/web/ui/Footer";

export default function PageFooter() {
    let activeBrand = 'United HealthCare Services, Inc. All rights reserved.';

    const loginTime = sessionStorage.getItem('login_time');
    const formattedLoginTime = loginTime
      ? new Date(loginTime).toLocaleString('en-US', {
          timeZone: 'America/Chicago',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        }) + ' CT'
      : '';

    return (
    <div style={{ position: 'fixed', bottom: 0, width: '100%' }}> 
    <Footer >
      <Footer.SubFooter
        copyright={activeBrand}
        bottomText={formattedLoginTime ? `Last login: ${formattedLoginTime}` : ''}
      />
    </Footer>
    </div>
  );
};